// extracted by mini-css-extract-plugin
module.exports = {"answerRight":"RightAnswer_answerRight__1H12c"};